import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { BYPASS_HEADERS } from '@feature/dashboard/documents/services/document.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authenticationService = inject(AuthenticationService);
  const jwtToken = authenticationService.getToken();
  

 // Check if the request has the BYPASS_HEADERS token set to true
  if (req.context.get(BYPASS_HEADERS) === true) {
    // Pass the request unchanged
    return next(req);
  }else{

    // Clone the request and add the authorization header
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${jwtToken}`,
      },
    });
  
    // Pass the cloned request with the updated header to the next handler
    return next(authReq);
  }

};
